import { validateBrikksByPersonalNumber, validateBrikksByAgreements, validateBrikksByPermissions } from 'utils/validation/brikks';

export const validateBrikks = (brikks, personalNumber, agreements, permissions) => {
  const validatedByPersonalNumber = validateBrikksByPersonalNumber(brikks, personalNumber);
  const validatedByAgreements = validateBrikksByAgreements(validatedByPersonalNumber, agreements);
  const validatedByPermissions = validateBrikksByPermissions(validatedByAgreements, permissions);

  return validatedByPermissions;
};
